export enum LinkAgentPayoutModalModes {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
  VIEW_FROM_LINK_AGENT_PROFILE = "viewFromLinkAgentProfile",
}
